__turbopack_context__.v({
  "attribution": "Nqcq8G_attribution",
  "content": "Nqcq8G_content",
  "image": "Nqcq8G_image",
  "imageWrapper": "Nqcq8G_imageWrapper",
  "noImage": "Nqcq8G_noImage",
  "restricted": "Nqcq8G_restricted",
  "text": "Nqcq8G_text",
  "textWrapper": "Nqcq8G_textWrapper",
});
